import { render, staticRenderFns } from "./Raccolta.vue?vue&type=template&id=dcb3f278"
import script from "./Raccolta.vue?vue&type=script&lang=js"
export * from "./Raccolta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports